import { ProcessoRelacionamentoService } from './../../processo-relacionamento/processo-relacionamento.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MensagemService, ProgressoService, Restricao, RestricaoOperador, RestricaoPadrao, Restricoes } from 'maestro-ng';
import { MenuItem, SelectItem } from 'primeng/api';
import { ArquivoVisualizavel } from '../../components/arquivo-visualizador/arquivo-visualizavel.model';
import { ProcessoDocumento } from '../../processo-documento/processo-documento.model';
import { ProcessoDocumentoService } from '../../processo-documento/processo-documento.service';
import { ProcessoMovimentoService } from '../../processo-movimento/processo-movimento.service';
import { ProcessoParteService } from '../../processo-parte/processo-parte.service';
import { isNullOrUndefined } from '../../util/utils';
import { Processo } from '../processo.model';
import { ProcessoService } from '../processo.service';
import { ProcessoAssuntoService } from './../../processo-assunto/processo-assunto.service';
import { ProcessoClasseService } from './../../processo-classe/processo-classe.service';
import { ProcessoDistribuicaoService } from './../../processo-distribuicao/processo-distribuicao.service';
import { ProcessoInstancia } from './../processo.model';
import { ProcessoAssunto } from '../../processo-assunto/processo-assunto.model';
import { ProcessoParte } from '../../processo-parte/processo-parte.model';
import { ProcessoMovimento } from '../../processo-movimento/processo-movimento.model';
import { ProcessoRelacionamento } from '../../processo-relacionamento/processo-relacionamento.model';
import { AutenticacaoService } from '../../autenticacao/autenticacao.service';
import { SelectItemService } from '../../services/select-item.service';
import { DataSourceRouted } from '../../util/data-source-routed';
import { ProcessoIdentificacaoPeticaoInicial } from '../../processo-identificacao-peticao-inicial/processo-identificacao-peticao-inicial.model';
import { ProcessoIdentificacaoPeticaoInicialService } from '../../processo-identificacao-peticao-inicial/processo-identificacao-peticao-inicial.service';
import { ProcessoCompiladoService } from '../../processo-compilado/processo-compilado.service';
// import { IdService } from '../../components/id/id.service';

@Component({
  selector: 'app-processo-visualizador',
  templateUrl: './processo-visualizador.component.html',
  styleUrls: ['./processo-visualizador.component.css'],
})
export class ProcessoVisualizadorComponent implements OnInit, OnChanges {
  public static TAB_DADOS = 1;
  public static TAB_ASSUNTOS = 2;
  public static TAB_CLASSES = 3;
  public static TAB_DISTRIBUICOES = 4;
  public static TAB_DOCUMENTOS = 5;
  public static TAB_MOVIMENTOS = 6;
  public static TAB_PARTES = 7;
  public static TAB_RELACIONAMENTOS = 8;
  public static TAB_LINHA_DO_TEMPO = 0;

  public static TAB_DOCUMENTOS_DADOS = 0;
  public static TAB_DOCUMENTOS_TEXTO = 2;
  public static TAB_DOCUMENTOS_ORIGINAL = 3;

  @Input()
  public processo: Processo;

  @Input()
  public tabViewIndex: number;

  @Input()
  public tabViewDocumentosIndex: number;

  @Output()
  public atribuiuPeticao = new EventEmitter();

  @Input()
  public mostrarComandoProcesso: boolean;

  dsAssunto: DataSourceRouted<ProcessoAssunto, number>;

  public dsParte: DataSourceRouted<ProcessoParte, number>;

  public dsMovimento: DataSourceRouted<ProcessoMovimento, number>;

  public dsRelacionamento: DataSourceRouted<ProcessoRelacionamento, number>;

  public dsDocumento: DataSourceRouted<ProcessoDocumento, number>;

  public processoDocumento: ProcessoDocumento;

  public processoIdentificacaoPeticaoInicial: ProcessoIdentificacaoPeticaoInicial;

  public processoDocumentoTexto: string;
  public processoDocumentoArquivo: ArquivoVisualizavel;
  public tipoRota: string;

  public partesItens: SelectItem[];
  public tipoArquivoItens: SelectItem[];
  public tipoRelacionamentoItens: SelectItem[];

  public permissaoProcessarArquivoEstruturaBtn = false;
  public atribuirPeticaoInicialBtn = false;
  public atribuirPeticaoInicialAusenteBtn = false;
  // public colunaTituloGeral: string = 'Id';

  public sincronizarItens: MenuItem[] = [
    { label: 'Documentos', icon: 'pi pi-file', command: () => this.sincronizarDocumentos() },
    { label: 'Partes', icon: 'pi pi-users', command: () => this.sincronizarPartes() },
    { label: 'Metadados', icon: 'pi pi-book', command: () => this.sincronizarMetadados() },
    { label: 'Movimentos', icon: 'pi pi-chart-line', command: () => this.sincronizarMovimentos() },
  ];

  public acoesItens: MenuItem[] = [
    { label: 'Priorizar Documentos', icon: 'pi pi-file', command: () => this.priorizarDocumentos() },
    { label: 'Reprocessar Indicadores', icon: 'pi pi-refresh', command: () => this.reprocessarIndicadores() },
    { label: 'Recompilar', icon: 'pi pi-reply', command: () => this.recompilar() },
  ];

  constructor(
    private service: ProcessoService,
    private processoAssuntoService: ProcessoAssuntoService,
    private processoClasseService: ProcessoClasseService,
    private processoDistribuicaoService: ProcessoDistribuicaoService,
    private processoDocumentoService: ProcessoDocumentoService,
    private processoMovimentoService: ProcessoMovimentoService,
    private processoParteService: ProcessoParteService,
    // private idService: IdService,
    private processoRelacionamentoService: ProcessoRelacionamentoService,
    private processoCompiladoService: ProcessoCompiladoService,
    private mensagemService: MensagemService,
    private route: ActivatedRoute,
    private router: Router,
    private progressoService: ProgressoService,
    private autenticacaoService: AutenticacaoService,
    private selectItemService: SelectItemService,
    private processoIdentificacaoPeticaoInicialService: ProcessoIdentificacaoPeticaoInicialService
  ) {}

  ngOnInit(): void {
    this.permissaoProcessarArquivoEstruturaBtn = this.autenticacaoService.temPermissaoExecucao(
      'rest/reprocessarArquivoEstruturaPorId/*'
    );
    this.atribuirPeticaoInicialBtn = this.autenticacaoService.temPermissaoExecucao('rest/atribuirPeticaoInicial*/*');
    this.atribuirPeticaoInicialAusenteBtn = this.autenticacaoService.temPermissaoExecucao('rest/atribuirPeticaoInicialAusente/*');
    this.partesItens = this.selectItemService.getPolos();
    this.tipoArquivoItens = this.selectItemService.getTipoArquivo();
    this.tipoRelacionamentoItens = this.selectItemService.getRelacionamentoTipo();

  //  this.colunaTituloGeral = this.idService.mostrarOrigemId ? 'Origem Id' : 'Id';
  }

  public ngOnChanges(_: SimpleChanges) {
    this.carregarDadosProcesso(this.processo);
  }

  public carregarDadosProcesso(processo: Processo): void {
    this.processo = processo;
    this.onChangeTabView(false);
  }

  public selecionarProcessoDocumento(processoDocumento: ProcessoDocumento): void {
    this.processoDocumento = processoDocumento;
    this.processoDocumentoTexto = '';
    this.processoDocumentoArquivo = undefined;
    this.onChangeTabViewDocumentos();
  }

  public carregarDocumentoTexto(processoDocumento: ProcessoDocumento) {
    if (processoDocumento.arquivo) {
      this.progressoService.modeless();
      this.processoDocumentoService
        .recuperarTextoPorId(processoDocumento.processo.id, processoDocumento.id)
        .then((texto) => {
          this.progressoService.fechar();
          this.processoDocumentoTexto = texto;
        })
        .catch((resposta) => this.catch('Erro ao recuperar a url de acesso ao recurso', resposta.error));
    }
  }

  public carregarDocumentoOriginal(processoDocumento: ProcessoDocumento) {
    this.progressoService.modeless();
    this.processoDocumentoService
      .recuperarConteudoPorId(processoDocumento.processo.id, processoDocumento.id)
      .then((conteudoOriginal) => {
        this.processoDocumentoArquivo = new ArquivoVisualizavel(
          processoDocumento.nome,
          processoDocumento.tipoArquivo,
          processoDocumento.categoriaArquivo,
          conteudoOriginal
        );
        this.progressoService.fechar();
      })
      .catch((resposta) => this.catch('Erro ao recuperar documento original', resposta.error));
  }

  private alterarRota() {
    const params = {
      tabView: this.tabViewIndex,
      tabViewDocumentos: this.tabViewDocumentosIndex,
    };

    if (this.router.url.indexOf(';') > 0) {
      const paramsHerdado = this.router.url.substring(this.router.url.indexOf(';') + 1).split(';');
      paramsHerdado.forEach((param) => {
        const primeiraParte = param.split('=')[0];
        const segundaParte = param.split('=')[1];
        if (primeiraParte !== 'tabView' && primeiraParte !== 'tabViewDocumentos') {
          params[primeiraParte] = segundaParte;
        }
      });
    }

    this.router.navigate([this.router.url.split(';')[0], params]);
  }

  public onChangeTabView(alterarRota: boolean) {
    if (alterarRota) {
      this.alterarRota();
    }

    switch (this.tabViewIndex) {
      case ProcessoVisualizadorComponent.TAB_ASSUNTOS:
        this.carregarAssuntos();
        break;
      case ProcessoVisualizadorComponent.TAB_CLASSES:
        this.carregarClasses();
        break;
      case ProcessoVisualizadorComponent.TAB_DISTRIBUICOES:
        this.carregarDistribuicoes();
        break;
      case ProcessoVisualizadorComponent.TAB_DOCUMENTOS:
        this.carregarDocumentos();
        break;
      case ProcessoVisualizadorComponent.TAB_MOVIMENTOS:
        this.carregarMovimentos();
        break;
      case ProcessoVisualizadorComponent.TAB_PARTES:
        this.carregarPartes();
        break;
      case ProcessoVisualizadorComponent.TAB_RELACIONAMENTOS:
        this.carregarRelacionamentos();
        break;
      case ProcessoVisualizadorComponent.TAB_DADOS:
        this.carregarDadosPeticaoInicial();
        break;
      case ProcessoVisualizadorComponent.TAB_LINHA_DO_TEMPO:
        this.carregarLinhaDoTempo();
        break;
    }
  }

  public carregarAssuntos(): void {
    this.progressoService.modeless();
    if (this.dsAssunto === undefined) {
      this.dsAssunto = new DataSourceRouted<ProcessoAssunto, number>(
        'processo-assunto',
        (c) => this.processoAssuntoService.recuperarPaginadoPorProcesso(this.processo.id, c),
        this.mensagemService,
        this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes([
          new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'origemId', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'assunto.descricao', operador: RestricaoOperador.CONTAINS }),
        ])
      );
    } else {
      this.dsAssunto.pesquisar();
    }
    this.progressoService.fechar();
  }

  public carregarClasses(): void {
    this.progressoService.modeless();
    this.processoClasseService
      .recuperarPorProcessoId(this.processo.id)
      .then((classes) => {
        this.processo.historicoClasses = classes;
        this.progressoService.fechar();
      })
      .catch((response) => this.catch('Erro ao carregar o histórico de classes do processo', response.error));
  }
  public carregarLinhaDoTempo(): void {
    this.progressoService.modeless();
    this.processoClasseService
      .recuperarPorProcessoId(this.processo.id)
      .then((classes) => {
        this.processo.historicoClasses = classes;
        return this.processoDistribuicaoService.recuperarPorProcessoId(this.processo.id);
      })
      .then((distribuicoes) => {
        this.processo.historicoDistribuicoes = distribuicoes;
        this.progressoService.fechar();
      })
      .catch((response) => this.catch('Erro ao carregar os dados da linha do tempo', response.error));
  }
  public carregarDistribuicoes(): void {
    this.progressoService.modeless();
    this.processoDistribuicaoService
      .recuperarPorProcessoId(this.processo.id)
      .then((distribuicoes) => {
        this.processo.historicoDistribuicoes = distribuicoes;
        this.progressoService.fechar();
      })
      .catch((response) => this.catch('Erro ao carregar o histórico de distribuições do processo', response.error));
  }

  public carregarDocumentos(): void {
    this.progressoService.modeless();
    if (this.dsDocumento === undefined) {
      this.dsDocumento = new DataSourceRouted<ProcessoDocumento, number>(
        'processo-documentos',
        (c) => this.processoDocumentoService.recuperarPaginadoPorProcesso(this.processo.id, c),
        this.mensagemService,
        this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes([
          new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'origemId', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'nome', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'tipoProcessoDocumentoLocal.nome', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'arquivo.tipo', operador: RestricaoOperador.EQUALS }),
          new Restricao<Date>({ atributo: 'dataJuntada', operador: RestricaoOperador.GE, padrao: RestricaoPadrao.DATE }),
        ])
      );
    } else {
      this.dsDocumento.pesquisar();
    }
    this.processarHierarquia(this.dsDocumento.entidades);
    this.processo.documentos = this.dsDocumento.entidades;
    this.processarProcessoDocumentosPais(this.dsDocumento.entidades);
    this.progressoService.fechar();
  }

  private processarHierarquia(documentos: ProcessoDocumento[]): void {
    if (documentos !== undefined) {
      const pais = documentos.filter((d) => d !== undefined && d.pai === undefined);
      const filhos = documentos.filter((d) => d !== undefined && d.pai !== undefined);
      filhos.forEach((f) => (f.pai = pais.filter((p) => p.id === f.pai.id)[0]));
      pais.forEach((p) => (p.filhos = filhos.filter((f) => f.pai === p)));
    }
  }

  private processarProcessoDocumentosPais(documentos: ProcessoDocumento[]): void {
    if (documentos !== undefined) {
      documentos.filter((documento) => documento.pai === undefined);
    }
  }

  public carregarMovimentos(): void {
    this.progressoService.modeless();
    if (this.dsMovimento === undefined) {
      this.dsMovimento = new DataSourceRouted<ProcessoMovimento, number>(
        'processo-movimentos',
        (c) => this.processoMovimentoService.recuperarPaginadoPorProcesso(this.processo.id, c),
        this.mensagemService,
        this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes([
          new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'origemId', operador: RestricaoOperador.EQUALS }),
          new Restricao<Date>({ atributo: 'data', operador: RestricaoOperador.GE, padrao: RestricaoPadrao.DATE }),
          new Restricao<string>({ atributo: 'tipo.nome', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'descricao', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'tipo.hierarquia', operador: RestricaoOperador.CONTAINS }),
        ])
      );
    } else {
      this.dsMovimento.pesquisar();
    }
    this.progressoService.fechar();
  }

  public carregarPartes(): void {
    this.progressoService.modeless();
    if (this.dsParte === undefined) {
      this.dsParte = new DataSourceRouted<ProcessoParte, number>(
        'processo-partes',
        (c) => this.processoParteService.recuperarPaginadoPorProcessoId(this.processo.id, c),
        this.mensagemService,
        this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes([
          new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'origemId', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'pessoa.nome', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'tipoParte.nome', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'polo', operador: RestricaoOperador.EQUALS }),
        ])
      );
    } else {
      this.dsParte.pesquisar();
    }
    this.progressoService.fechar();
  }

  public carregarRelacionamentos(): void {
    this.progressoService.modeless();
    if (this.dsRelacionamento === undefined) {
      this.dsRelacionamento = new DataSourceRouted<ProcessoRelacionamento, number>(
        'processo-relacionamentos',
        (c) => this.processoRelacionamentoService.recuperarPaginadoPorProcessoId(this.processo.id, c),
        this.mensagemService,
        this.progressoService,
        this.route,
        this.router,
        100,
        new Restricoes([
          new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'origemId', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'tipo', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'classe.descricao', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'numeroProcesso', operador: RestricaoOperador.CONTAINS }),
        ])
      );
    } else {
      this.dsRelacionamento.pesquisar();
    }
  }

  public onChangeTabViewDocumentos() {
    this.alterarRota();

    switch (this.tabViewDocumentosIndex) {
      case ProcessoVisualizadorComponent.TAB_DOCUMENTOS_ORIGINAL:
        this.carregarDocumentoOriginal(this.processoDocumento);
        break;
      case ProcessoVisualizadorComponent.TAB_DOCUMENTOS_TEXTO:
        this.carregarDocumentoTexto(this.processoDocumento);
        break;
    }
  }

  public reprocessarArquivoEstrutura(): void {
    if (this.processoDocumento !== undefined) {
      this.progressoService.modal();
      this.processoDocumentoService
        .reprocessarArquivoEstruturaPorId(this.processo.id, this.processoDocumento.id)
        .then((_) => {
          this.onChangeTabViewDocumentos();
          this.progressoService.fechar();
          this.mensagemService.addSucesso('Sucesso', 'O arquivo foi reprocessado com sucesso!');
        })
        .catch((response) => this.catch('Erro ao realizar o reprocessamento do arquivo estrutura', response.error));
    }
  }

  public processarArquivoEstrutura(): void {
    if (this.processoDocumento !== undefined) {
      this.progressoService.modal();
      this.processoDocumentoService
        .processarArquivoEstruturaPorId(this.processo.id, this.processoDocumento.id)
        .then((_) => {
          this.processoDocumentoService
            .recuperarPorProcessoId(this.processo.id)
            .then((documentos) => {
              this.processoDocumento.processado = true;
              this.processo.documentos = documentos;
              this.processarHierarquia(this.processo.documentos);
              this.selecionarProcessoDocumento(documentos.filter((documento) => documento.id === this.processoDocumento.id)[0]);
              this.progressoService.fechar();
              this.mensagemService.addSucesso('Sucesso', 'O arquivo foi processado com sucesso!');
            })
            .catch((response) => this.catch('Erro ao carregar os documentos', response.error));
        })
        .catch((response) => this.catch('Erro ao realizar o reprocessamento do arquivo estrutura', response.error));
    }
  }

  public sincronizarDocumentos(): void {
    this.progressoService.modal();
    this.service
      .sincronizarDocumentos(this.processo.id)
      .then((processo) => {
        this.progressoService.fechar();
        this.carregarDadosProcesso(processo);
        this.mensagemService.addSucesso('Sucesso', 'A sincronização dos documentos do processo foi realizada com sucesso!');
      })
      .catch((response) => this.catch('Erro ao sincronizar os documentos', response.error));
  }

  public sincronizarPartes(): void {
    this.progressoService.modal();
    this.service
      .sincronizarPartes(this.processo.id)
      .then((processo) => {
        this.progressoService.fechar();
        this.carregarDadosProcesso(processo);
        this.mensagemService.addSucesso('Sucesso', 'A sincronização das partes do processo foi realizada com sucesso!');
      })
      .catch((response) => this.catch('Erro ao sincronizar as partes', response.error));
  }

  public sincronizarMetadados(): void {
    this.progressoService.modal();
    this.service
      .sincronizarMetadados(this.processo.id)
      .then((processo) => {
        this.progressoService.fechar();
        this.carregarDadosProcesso(processo);
        this.mensagemService.addSucesso('Sucesso', 'A sincronização dos metadados do processo foi realizada com sucesso!');
      })
      .catch((response) => this.catch('Erro ao sincronizar os metadados', response.error));
  }

  public sincronizarMovimentos(): void {
    this.progressoService.modal();
    this.service
      .sincronizarMovimentos(this.processo.id)
      .then((processo) => {
        this.progressoService.fechar();
        this.carregarDadosProcesso(processo);
        this.mensagemService.addSucesso('Sucesso', 'A sincronização dos movimentos do processo foi realizada com sucesso!');
      })
      .catch((response) => this.catch('Erro ao sincronizar os movimentos', response.error));
  }

  public priorizarDocumentos(): void {
    this.progressoService.modal();
    this.service
      .priorizarDocumentos(this.processo)
      .then((processo) => {
        this.progressoService.fechar();
        this.carregarDadosProcesso(processo);
        this.mensagemService.addSucesso('Sucesso', 'Os Documentos foram priorizados com sucesso!');
      })
      .catch((response) => this.catch('Erro ao priorizar documentos', response.error));
  }

  public reprocessarIndicadores(): void {
    if (this.processo.id !== undefined) {
      this.progressoService.modal();
      this.service
        .reprocessarIndicadores(this.processo)
        .then(() => {
          this.progressoService.fechar();
          this.mensagemService.addSucesso('Sucesso', 'Os Indicadores foram reprocessados com sucesso!');
        })
        .catch((response) => {
          console.error(response);
        });
    }
  }

  public recompilar(): void {
    this.progressoService.modal();
    this.processoCompiladoService
      .recompilar(this.processo.id)
      .then(() => {
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'Os processos foram recompilados com sucesso!');
      })
      .catch((response) => this.catch('Erro ao recompilar os processos.', response.error));
  }

  public carregarDadosPeticaoInicial(): void {
    this.progressoService.modeless();
    this.processoIdentificacaoPeticaoInicialService
      .recuperarPorId(this.processo.id)
      .then((processoIdentificacaoPeticaoInicial) => {
        this.progressoService.fechar();
        this.processoIdentificacaoPeticaoInicial = processoIdentificacaoPeticaoInicial;
      })
      .catch((response) => this.catch('Erro ao identificar peticão inicial', response.error));
  }

  public catch(titulo: string, mensagem: string): void {
    this.progressoService.fechar();
    this.mensagemService.addErro(titulo, mensagem);
  }

  public atribuirPeticaoInicial(): void {
    if (this.processo !== undefined && this.processoDocumento !== undefined) {
      this.progressoService.modal();
      this.service
        .atribuirPeticaoInicial(this.processo, this.processoDocumento)
        .then((processo) => {
          this.processo.peticaoInicial = processo.peticaoInicial;
          this.processo.dataAnalisePeticaoInicialManual = processo.dataAnalisePeticaoInicialManual;
          this.mensagemService.addSucesso(
            'Petição Inicial atribuída com sucesso',
            'Inserido o Documento: ' + processo.peticaoInicial.id + ' como petição Inicial'
          );
          this.atribuiuPeticao.emit(processo);
          this.progressoService.fechar();
        })
        .catch((response) => this.catch('Erro ao atribuir petição inicial ao processo.', response.error));
    }
  }

  public getClassePeticaoAtribuida(processo: Processo): string {
    let classe: string;

    if (
      !isNullOrUndefined(processo.dataAnalisePeticaoInicialAutomatica) ||
      !isNullOrUndefined(processo.dataAnalisePeticaoInicialManual)
    ) {
      if (!isNullOrUndefined(processo.peticaoInicial)) {
        if (!isNullOrUndefined(processo.dataAnalisePeticaoInicialManual)) {
          classe = 'pi pi-bars peticao-inicial';
        } else {
          classe = 'pi pi-android peticao-inicial';
        }
      } else {
        if (!isNullOrUndefined(processo.dataAnalisePeticaoInicialManual)) {
          classe = 'pi pi-bars peticao-inicial-ausente';
        } else {
          classe = 'pi pi-android peticao-inicial-ausente';
        }
      }
    } else {
      classe = '';
    }
    return classe;
  }

  public atribuirPeticaoInicialAusente(): void {
    if (this.processo !== undefined) {
      this.progressoService.modal();
      this.service
        .atribuirPeticaoAusente(this.processo)
        .then((processo) => {
          this.processo.peticaoInicial = undefined;
          this.processo.dataAnalisePeticaoInicialManual = processo.dataAnalisePeticaoInicialManual;
          this.mensagemService.addSucesso('Petição Inicial atribuída com sucesso', 'Petição Inicial definida como ausente');
          this.atribuiuPeticao.emit(processo);
          this.progressoService.fechar();
        })
        .catch((response) => this.catch('Erro ao atribuir petição inicial ausente ao processo.', response.error));
    }
  }

  isSegundoGrau(): boolean {
    return this.processo !== undefined && this.processo !== null && this.processo.instancia === ProcessoInstancia.SEGUNDO_GRAU;
  }

  // public alternarColunaGlobal(): void {
  //   this.idService.alternarColunaGlobal();
  // }
}
